<template>
  <div class="case">
    <banner :img="require('@/assets/img/bgtop.jpg')" title="产品详情" :height="150" />
    <div class="case-product">
      <div class="case-product-content">
        <!-- 产品图片轮播 -->
        <div class="product-gallery">
          <div class="main-image">
            <img
              :src="getImageSrc(currentImage)"
              :alt="caseDetail.Title"
              class="main-product-image"
            />
          </div>
          <div class="thumbnail-list">
            <img
              v-for="(image, index) in caseDetail.Images"
              :key="index"
              :src="getImageSrc(image)"
              :alt="`缩略图 ${index + 1}`"
              :class="['thumbnail', { active: currentIndex === index }]"
              @click="setCurrentImage(index)"
            />
          </div>
        </div>

        <!-- 产品信息 -->
        <div class="product-info-section">
          <h2 class="product-title">{{ caseDetail.Title }}</h2>
          <p class="product-time">发布时间：{{ formattedCreateTime }}</p>

          <div class="product-description">
            <h3>产品简介</h3>
            <p class="product-content" v-html="caseDetail.Content"></p>
          </div>

          </div>
        </div>
      </div>

      <!-- 操作栏 -->
      <div class="action-bar">
        <router-link
          to="/case"
          class="back-button">
          <i class="icon-arrow-left"></i> 返回产品列表
        </router-link>
        <a
          v-if="caseDetail.SpecSheet"
          :href="caseDetail.SpecSheet"
          class="download-button"
          target="_blank">
          <i class="icon-download"></i> 下载规格书
        </a>
      </div>
    </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  components: {
    Banner
  },
  data() {
    return {
      caseDetail: {
        Title: "未知产品",
        Content: "该产品信息暂未录入系统",
        CreateTime: new Date().toISOString(),
        Images: ["default-product.jpg"],
        SpecSheet: ""
      },
      currentIndex: 0 // 当前显示的图片索引
    };
  },
  computed: {
    // 当前显示的图片
    currentImage() {
      return this.caseDetail.Images[this.currentIndex];
    },
    // 格式化创建时间
    formattedCreateTime() {
      const date = new Date(this.caseDetail.CreateTime);
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  },
  created() {
    this.loadProductDetail();
  },
  methods: {
    loadProductDetail() {
      const productId = this.$route.params.id;
      const staticProducts = {
        1000: {
          Id: 1000,
          Title: "S628 一体机28串",
          Content: "S628 系列智能电池管理系统高度集成隔离 DC 模块、数据采集、总压检测、绝缘检测、无线传输等功能，核心器件选型全部满足要求，支持磷酸铁锂、三元、钛酸锂等电池类型；体积小、重量轻，具有超高性价比。适用于叉车、牵引车、举升车等各类工业车辆。双 CPU 电源管理，功耗分配更科学；符合 EN ISO13849-1 安全的设计，最高可达 PL=D 的安全等级。符合 EN12895 的 EMC 设计；内部集成高性能隔离 DC 模块，电池系统设计不再需要传统的 DC 模块；高度集成绝缘检测、高压检测、充电口温度检测、高压互锁、数据存储、无线数据传输等丰富功能，辅以数十项硬件自检电路，提供丰富的接口定义；基于 ISO14229 标准的 CAN 网络通讯、符合 AUTOSAR 规范的软件架构设计、严格的 MISRA C 代码规范，确保软件安全；系统级可靠性设计、IPD 研发流程管理、CNAS 实验室配套支持、IATF16949 质量管理体系，确保产品品质无忧；业内独有的标定工作模式、联网刷机工具与 OTA 空中升级系统，配合产品后台管理平台，轻松实现产品软件封闭管理与可追溯；电池数据云平台提供强大的数据监控、状态查询、报警预警、数据分析、参数再标定功能，完成对电池系统的全生命周期管理。",
          CreateTime: "2023-08-20T09:00:00",
          Images: ["product-s618-1000.png", "product-s618-1000-1.png"],
          SpecSheet: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/24/1771915195212_393_益华通盛 S628系列智能电池管理系统产品规格书_V1.1.pdf"
        },
        2000: {
          Id: 2000,
          Title: "S618 一体机18串",
          Content: "S618 系列智能电池管理系统高度集成隔离 DC 模块、数据采集、总压检测、绝缘检测、无线传输等功能，核心器件选型全部满足要求，支持磷酸铁锂、三元、钛酸锂等电池类型；体积小、重量轻，具有超高性价比。适用于叉车、牵引车、举升车等各类工业车辆。双 CPU 电源管理，功耗分配更科学；符合 EN ISO13849-1 安全的设计，最高可达 PL=D 的安全等级。符合 EN12895 的 EMC 设计；内部集成高性能隔离 DC 模块，电池系统设计不再需要传统的 DC 模块；高度集成绝缘检测、高压检测、充电口温度检测、高压互锁、数据存储、无线数据传输等丰富功能，辅以数十项硬件自检电路，提供丰富的接口定义；基于 ISO14229 标准的 CAN 网络通讯、符合 AUTOSAR 规范的软件架构设计、严格的 MISRA C 代码规范，确保软件安全；系统级可靠性设计、IPD 研发流程管理、CNAS 实验室配套支持、IATF16949 质量管理体系，确保产品品质无忧；业内独有的标定工作模式、联网刷机工具与 OTA 空中升级系统，配合产品后台管理平台，轻松实现产品软件封闭管理与可追溯；电池数据云平台提供强大的数据监控、状态查询、报警预警、数据分析、参数再标定功能，完成对电池系统的全生命周期管理。",
          CreateTime: "2023-08-20T09:00:00",
          Images: ["product-s618-2000.png", "product-s618-2000-1.png"],
          SpecSheet: "http://139.9.64.10:16001/forklift-test/2025/04/14/ecede8ae-60e2-417a-ae8c-b10adc8aa3c0.pdf"
        },
        3000: {
          Id: 3000,
          Title: "S608 一体机8串",
          Content: "S608 智能电池管理系统是由益华通盛科技专为举升车（平台）量身打造的新一代智能电池管理解决方案。系统针对24V电压平台应用场景，深度融合\"强抗干扰、实时监控、便捷维护\"等核心需求，全面提升设备运行的可靠性与运维效率，适用于各类24V举升车及作业平台",
          CreateTime: "2025-01-18T10:00:00",
          Images: ["product-s618-3000.png", "product-s618-3000-1.png"],
          SpecSheet: "https://forklift.ehuatech.com.cn/forklift-test/2025/12/26/1766735601705_965_【益华通盛】S608智能电池管理系统规格书V1.1(1).pdf"
        },
        3338: {
          Id: 3338,
          Title: "X338-1550H",
          Content: "15串50A硬件保护板",
          CreateTime: "2025-08-21T10:00:00",
          Images: ["product-xjg-3338.png"],
          SpecSheet: "https://forklift.ehuatech.com.cn/forklift-test/2025/12/25/1766659665780_308_EH-PHI15S050锂电池硬件保护板产品规格书338.pdf"
        },
        3360: {
          Id: 3360,
          Title: "X360-0850S",
          Content: "8串50A软件保护板",
          CreateTime: "2025-08-21T10:00:00",
          Images: ["product-xjg-3360.png"],
          SpecSheet: "https://forklift.ehuatech.com.cn/forklift-test/2025/12/25/1766660060425_795_EH-PSI8S050锂电池智能软件保护板产品规格书360.pdf"
        },
        3369: {
          Id: 3369,
          Title: "X369-1550S",
          Content: "15串50A软件保护板",
          CreateTime: "2025-08-21T10:00:00",
          Images: ["product-xjg-3369.png"],
          SpecSheet: "https://forklift.ehuatech.com.cn/forklift-test/2025/12/25/1766660113185_137_EH-PSI15S050锂电池智能软件保护板产品规格书369.pdf"
        },
        3487: {
          Id: 3487,
          Title: "X487-0880S",
          Content: "8串80A软件保护板",
          CreateTime: "2025-08-21T10:00:00",
          Images: ["product-xjg-3487.png"],
          SpecSheet: "https://forklift.ehuatech.com.cn/forklift-test/2025/12/25/1766660187279_916_EH-PSI8S080锂电池智能软件保护板产品规格书487.pdf"
        },
        3512: {
          Id: 3512,
          Title: "X512-1550S",
          Content: "15串50A-UL软件版(B+螺柱款)",
          CreateTime: "2025-08-21T10:00:00",
          Images: ["product-xjg-3512.png"],
          SpecSheet: "https://forklift.ehuatech.com.cn/forklift-test/2025/12/25/1766660265579_573_EH-PSI15S050UL锂电池智能软件保护板产品规格书512.pdf"
        },
        4000: {
          Id: 4000,
          Title: "S618 分体机",
          Content: "S618 分体机。",
          CreateTime: "2023-08-21T10:00:00",
          Images: ["product-s618-4000.png", "product-s618-4000-1.png"],
          SpecSheet: "s618.pdf"
        },
        5000: {
          Id: 5000,
          Title: "4G模块",
          Content: "支持多种协议，超强信号",
          CreateTime: "2023-08-21T10:00:00",
          Images: ["product-s618-5000.png"],
          SpecSheet: "s618.pdf"
        },
        6000: {
          Id: 6000,
          Title: "WiFi模块",
          Content: "支持华为协议，超强信号",
          CreateTime: "2023-08-21T10:00:00",
          Images: ["product-s618-6000.png"],
          SpecSheet: "http://139.9.64.10:16001/forklift-test/2025/04/03/a57f15cd-59d4-4851-a41c-988507ee1365.pdf"
        }
      };

      this.caseDetail = staticProducts[productId] || this.caseDetail;
      this.currentIndex = 0; // 初始化显示第一张图片
    },
    setCurrentImage(index) {
      this.currentIndex = index;
    },
    getImageSrc(image) {
      // 如果image是URL格式，直接返回；否则使用require引用本地资源
      if (image.startsWith('http://') || image.startsWith('https://')) {
        return image;
      } else {
        return require(`@/assets/img/${image}`);
      }
    }
  }
};
</script>

<style scoped>
.case-product {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.case-product-content {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  margin-top: 20px; /* 向下移动 */
  margin-left: 15px; /* 向左移动 */
}

.product-gallery {
  flex: 1;
  min-width: 400px;
}

.main-image {
  width: 100%;
  height: 550px; /* 从300px增加到550px */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 15px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.main-product-image {
  max-width: 100%;
  max-height: 500px; /* 增加最大高度以适应容器 */
  object-fit: contain;
  border-radius: 4px;
}

.thumbnail-list {
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}

.thumbnail {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  opacity: 0.6;
}

.thumbnail:hover,
.thumbnail.active {
  opacity: 1;
  border-color: #1a75bb;
  transform: scale(1.05);
}

.product-info-section {
  flex: 1;
  min-width: 400px;
}

.product-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 2px solid #eee;
}

.product-time {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.product-description {
  margin-bottom: 20px;
}

.product-description h3 {
  font-size: 20px;
  color: #1a75bb;
  margin-bottom: 15px;
}

.product-content {
  font-size: 16px;
  color: #444;
  line-height: 1.6;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.download-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.download-button {
  display: inline-block;
  padding: 12px 24px;
  background-color: #28a745;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  font-weight: 500;
}

.download-button:hover {
  background-color: #218838;
  transform: translateY(-2px);
}

.action-bar {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.back-button {
  display: inline-block;
  padding: 12px 24px;
  background-color: #007bff;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  font-weight: 500;
}

.back-button:hover {
  background-color: #0056b3;
  transform: translateY(-2px);
}

.back-button i,
.download-button i {
  margin-right: 5px;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .case-product-content {
    flex-direction: column;
  }

  .product-gallery,
  .product-info-section {
    min-width: auto;
  }

  .main-image {
    height: 300px;
  }

  .action-bar {
    flex-direction: column;
    align-items: center;
  }
}
</style>
